import Alpine from 'alpinejs';

// Scroll-driven parallax: writes a `--parallax-progress` CSS
// variable (0..1) on the element based on how far it has scrolled
// through the viewport. SCSS uses that variable to drive transforms
// continuously, so the element keeps moving as the page scrolls
// rather than snapping when it enters view.
//
// Progress definition:
//   0 → element's centre is at the BOTTOM of the viewport (just
//       entering from below)
//   0.5 → element's centre is at the MIDDLE of the viewport
//   1 → element's centre is at the TOP of the viewport (about to
//       exit upwards)
// Values are clamped to [0, 1] outside that range so the element
// settles at the extremes instead of running away.
//
// rAF-throttled so scroll callbacks fire at most once per frame.
Alpine.data('parallax', () => ({
  rafId: null,
  handleScroll: null,

  init() {
    this.handleScroll = () => {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        this.update();
        this.rafId = null;
      });
    };

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });
    // Run once on init so the element doesn't render at progress 0
    // until the first scroll.
    this.update();
  },

  destroy() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  },

  update() {
    const rect = this.$el.getBoundingClientRect();
    const vh   = window.innerHeight;
    if (vh === 0) return;

    const centerY  = rect.top + rect.height / 2;
    const progress = 1 - centerY / vh;
    const clamped  = Math.max(0, Math.min(1, progress));

    this.$el.style.setProperty('--parallax-progress', clamped.toFixed(3));
  }
}));
